



// 



import { Component } from '@angular/core';
import { fadeInOut } from '../../../services/animations';
import { ApiService } from '../../../services/api.service';
import { MatDialog } from '@angular/material';
import { AlertService, DialogType } from '../../../services/alert.service';
import { CreateEditServiceModalComponent } from './create-edit-service-modal/create-edit-service-modal.component';
import { Router } from '@angular/router';
import { Service } from '../../../models/service.model';

@Component({
    selector: 'services',
    template: require('./services.component.html'),
    styles: [require('./services.component.css')],
    animations: [fadeInOut]
})
export class ServicesComponent {
    services: Service[];
    constructor(private router: Router, private apiService: ApiService, public dialog: MatDialog, private alertService: AlertService) {
        this.getServices();
    }

    getServices() {
        this.apiService.getServices().subscribe(r => {
            this.services = r;
        })
    }

    createEditService(service: any) {
        let dialogRef = this.dialog.open(CreateEditServiceModalComponent, {
            width: '600px',
            data: {
                currentService: service || {},
                //vendors: this.Services
            }
        });

        dialogRef.afterClosed().subscribe(r => {
            this.getServices();
        })
    }

    deleteService(serviceId: number) {
        this.alertService.showDialog("Do you want to delete this service ?", DialogType.confirm, val => {

            this.apiService.deleteService(serviceId).subscribe(r => {
                this.getServices();
            });
        });
    }

    onActivate(event) {
        if (event.type === 'click') {
            this.router.navigate(['/services/' + event.row.serviceId]);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/quote-settings/services/services.component.ts